<template>
  <div id="benutzerObj">
      <div class="field email">
          {{ userObj.vorname }} {{ userObj.nachname }}
      </div>
      <div class="field middleAligned">
          <label for="freigeschalten">freigeschalten:</label>
          <input @click="freischalten()" id="freigeschalten" :checked="userObj.freigeschalten" type="checkbox">
      </div>
      <div class="field right-aligned">
          <button @click="benutzerBearbeiten()" class="fa">&#xf044;</button>
          <button @click="benutzerLoeschen()" class="buttonDelete fa">&#xf1f8;</button>
      </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import {Benutzer} from '@/backend_controller/benutzer.js';
import { Rollen } from '@/backend_controller/rollen';

export default {
  name: "BenutzerObj",
  components: {},
  props: {
      userObj: Object,
  },
  data() {
      return {
      };
  },
  methods: {
    async freischalten(){
      if(this.$props.userObj.freigeschalten){
        await Swal.fire({
          title: "Freischaltung wirklich entfernen?",
          showDenyButton: true,
          //showCancelButton: true,
          confirmButtonText: "Entfernen",
          denyButtonText: `Nicht entfernen`
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateBenutzer(this.$props.userObj.email, this.$props.userObj.passwort, this.$props.userObj.konvKey, this.$props.userObj.feuerwehrID, !this.$props.userObj.freigeschalten, this.$props.userObj.vorname, this.$props.userObj.nachname)
          } else if (result.isDenied) {
            this.$props.userObj.freigeschalten = true;
            return;
          }
        });
      } else{
        this.updateBenutzer(this.$props.userObj.email, this.$props.userObj.passwort, this.$props.userObj.konvKey, this.$props.userObj.feuerwehrID, !this.$props.userObj.freigeschalten, this.$props.userObj.vorname, this.$props.userObj.nachname)
            var subject = "Benutzer im Feuerwehr-Server aktiviert";
            var text = 'Ihr Benutzer wurde erfolgreich aktiviert. Sie haben nun nach einer erneuten Anmeldung vollständigen Zugriff auf den Feuerwehr-Server. Den Feuerwehr-Server können Sie über https://feuerwehr-server.org/ erreichen"';
            var to = this.$props.userObj.email;
            this.sendEmail(subject, text, to);
      }
    },
    async sendEmail(subject, text, to) {
            const emailData = {
                to: to,
                subject: subject,
                text: text
            };

            try {
                const response = await fetch('https://feuerwehr-server.org:5000/send-email', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(emailData)
                });

                if (!response.ok) {
                    const errorText = await response.text(); // Fehlernachricht vom Server lesen
                    console.error('Error sending email:', errorText);
                    throw new Error(`Failed to send email: ${errorText}`);
                }

                console.log('Email sent successfully!');
            } catch (error) {
                console.error('Error in sendEmail:', error);
            }
        },
    async updateBenutzer(email, passwort, konvKey, feuerwehrID, freigeschalten, vorname, nachname){

      const benutzerData = {
        email: email,
        passwort: passwort,
        konvKey: konvKey,
        feuerwehrID: feuerwehrID,
        freigeschalten: freigeschalten,
        vorname: vorname,
        nachname: nachname
      };

      await Benutzer.update(benutzerData);
    },
    async benutzerLoeschen(){
      await Swal.fire({
          title: "Benutzer dauerhaft löschen?",
          showDenyButton: true,
          //showCancelButton: true,
          confirmButtonText: "Löschen",
          denyButtonText: `Nicht Löschen`
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleteUser();
            //Swal.fire("Hydrant erfolgreich gelöscht", "", "success");
          } else if (result.isDenied) {
            //Swal.fire("Changes are not saved", "", "info");
          }
        });
    },
    async deleteUser(){
      if(await this.getBenutzerDefaults()){
        await this.deleteBenutzerDefault();
      }
      
      var response = await Benutzer.delete(this.$props.userObj.email);
      if(response){
        Swal.fire("Benutzer wurde erfolgreich gelöscht", "", "success");
        this.$emit('updateBenutzerTable');
      } else{
        Swal.fire(
                'Fehler beim Löschen!',
                '',
                'error'
            );
      }
    },
    async getBenutzerDefaults() {
        try{
            var konvKey = this.$route.params.id.replace(":","");
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/defaultwerte',
                { params: { konvKey: konvKey } }
            );
            //return response.data;
            console.log(response.data)
            return true;
        } catch (err){
            console.log(err);
            return false;
        }
    },
    async deleteBenutzerDefault(){
      try{
          await axios.delete(
              'https://feuerwehr-server.org:5000/deleteDefaultwerte',
              { params: { email: this.$props.userObj.email } }
          );
      } catch (err){
          console.log(err);
      };
    },
    async benutzerBearbeiten() {
      let rollen = await Rollen.get(this.$props.userObj.email);
      console.log(rollen);
      var html = `
      <div style="text-align:left; max-height:300px; overflow-y:auto;">
        <label><b>Rollen auswählen</b></label>
        <div id="rollenContainer">
          ${rollen.map(r => `
            <div style="margin:6px 0;">
              <input type="checkbox" id="rolle_${r.id}" value="${r.id}" ${r.active ? "checked" : ""}>
              <label for="rolle_${r.id}">
                <b>${r.name}</b> – ${r.beschreibung}
              </label>
            </div>
          `).join("")}
        </div>
      </div>
      `;

      const { value: formValues } = await Swal.fire({
        title: "Benutzer bearbeiten",
        html: html,
        focusConfirm: false,
        preConfirm: () => {
          const selectedRoles = Array.from(
            document.querySelectorAll('#rollenContainer input[type="checkbox"]:checked')
          ).map(cb => cb.value);

          return {
            rollenIDs: selectedRoles
          };
        }
      });
      if (formValues) {
        console.log(formValues.rollenIDs); 
        await Rollen.save(this.$props.userObj.email, formValues.rollenIDs)
      }
    },
  },
  async created() {
      console.log(this.$props.userObj);
  },
};
</script>

<style lang="scss">
#benutzerObj {
  font-size: x-large;
  display: flex;
  justify-content: space-between;
  margin-left: 10%;
  margin-right: 10%;
  background-color: white;
  border: solid black 0.2rem;
  margin-bottom: -0.1rem;
  padding: 0.3rem;

  @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      .field{
        width: auto !important;
      }
  }
}

.field {
  display: flex;
  align-items: center;
  width: 27%;
  margin-left: 1%;
  margin-right: 1%;
  button{
    font-size: xx-large;
    background-color: transparent;
    border: none;
  }
  button:hover{
    cursor:pointer;
  }
}

.field.email {
  flex: 1; /* Takes up remaining space */
}

.field.right-aligned {
  justify-content: flex-end;
  text-align: right;
}

.field.middleAligned{
  justify-content:center;
}

.buttonDelete{
  margin-left: 0.2rem;
}
</style>